/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface InitialCategoryField
 */
export interface InitialCategoryField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof InitialCategoryField
     */
    value: string;
}

/**
 * Check if a given object implements the InitialCategoryField interface.
 */
export function instanceOfInitialCategoryField(value: object): value is InitialCategoryField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function InitialCategoryFieldFromJSON(json: any): InitialCategoryField {
    return InitialCategoryFieldFromJSONTyped(json, false);
}

export function InitialCategoryFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitialCategoryField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function InitialCategoryFieldToJSON(value?: InitialCategoryField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

